<template>
  <div class="content">
    <div class="time">time1{{time1}}</div>
    <div class="time">time2{{time2}}</div>
     <input
            type="file"
            name=""
            id="upfile"
            accept="image/*"
          />
  </div>
</template>

<script>
import http from "../../../service/http";

export default {
  data() {
    return {
      time: "2020-10-29 16:08:28",
      time1: "",
      time2:''
    };
  },
  mounted() {
    this.gettime(this.time);
  },
  methods: {
    gettime(e) {
      e=e.replace(/-/g,'/');
      console.log(e)
       var date = Date.parse(e) + 2592000000;
       this.time2=Date.parse(e);
       var time1= http.timestampToTime(date);
       this.time1=time1
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/content/textsss.vue